module.exports = __webpack_public_path__ + "img/Pdf.80de390d.svg";